import { useLayoutEffect } from 'react';

const restoreThemeAttribute = (element, previousValue) => {
  if (!element) return;

  if (previousValue === null) {
    element.removeAttribute('data-theme');
    return;
  }

  element.setAttribute('data-theme', previousValue);
};

const useCustomerLandingLightTheme = () => {
  useLayoutEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const root = document.documentElement;
    const body = document.body;
    const previousRootTheme = root?.getAttribute('data-theme') ?? null;
    const previousBodyTheme = body?.getAttribute('data-theme') ?? null;

    root?.setAttribute('data-theme', 'light');
    body?.setAttribute('data-theme', 'light');

    return () => {
      restoreThemeAttribute(root, previousRootTheme);
      restoreThemeAttribute(body, previousBodyTheme);
    };
  }, []);
};

export default useCustomerLandingLightTheme;
